import { fmt } from './fmt.js';
const interpolateModifierMap = Object.assign(Object.create(null), {
    'e': 'html',
    'u': 'url',
    'l': 'lower',
    'rl': 'rawLower',
    'U': 'upper',
    'rU': 'rawUpper',
    't': 'title',
    'c': 'capitalize',
    '': '',
});
/**
 * Interpolate data into a string, with `${key}` or `${mode|key}`
 * Uses {@link fmt} under the hood, and also accepts {@link InterpolateModifier} shorthands
 */
export function interpolate(pattern, data) {
    return pattern.replace(/\${([a-zA-Z0-9_$]+)(?:}|\|([a-zA-Z0-9_$]+)})/g, (_, op, match) => {
        if (match) {
            if (match in {})
                return '';
            return fmtMatch(op, 
            // eslint-disable-next-line security/detect-object-injection
            data[match]);
        }
        else {
            if (op in {})
                return '';
            // eslint-disable-next-line security/detect-object-injection
            return fmtMatch('', data[op]);
        }
    });
}
/**
 * Format data with either a {@link FmtMode} or an {@link InterpolateModifier} shorthand
 */
export function fmtMatch(op, match) {
    if (op in interpolateModifierMap)
        op = interpolateModifierMap[op];
    return fmt(op, match);
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW50ZXJwb2xhdGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW50ZXJwb2xhdGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLEdBQUcsRUFBRSxNQUFNLFVBQVUsQ0FBQTtBQUc5QixNQUFNLHNCQUFzQixHQUMzQixNQUFNLENBQUMsTUFBTSxDQUFDLE1BQU0sQ0FBQyxNQUFNLENBQUMsSUFBSSxDQUFDLEVBQUU7SUFDbEMsR0FBRyxFQUFFLE1BQU07SUFDWCxHQUFHLEVBQUUsS0FBSztJQUNWLEdBQUcsRUFBRSxPQUFPO0lBQ1osSUFBSSxFQUFFLFVBQVU7SUFDaEIsR0FBRyxFQUFFLE9BQU87SUFDWixJQUFJLEVBQUUsVUFBVTtJQUNoQixHQUFHLEVBQUUsT0FBTztJQUNaLEdBQUcsRUFBRSxZQUFZO0lBQ2pCLEVBQUUsRUFBRSxFQUFFO0NBQ04sQ0FBQyxDQUFBO0FBRUg7OztHQUdHO0FBQ0gsTUFBTSxVQUFVLFdBQVcsQ0FDMUIsT0FBZSxFQUNmLElBQTZDO0lBRTdDLE9BQU8sT0FBTyxDQUFDLE9BQU8sQ0FDckIsK0NBQStDLEVBQy9DLENBQUMsQ0FBQyxFQUFFLEVBQVUsRUFBRSxLQUF5QixFQUFFLEVBQUU7UUFDNUMsSUFBSSxLQUFLLEVBQUUsQ0FBQztZQUNYLElBQUksS0FBSyxJQUFJLEVBQUU7Z0JBQUUsT0FBTyxFQUFFLENBQUE7WUFDMUIsT0FBTyxRQUFRLENBQ2QsRUFBbUM7WUFDbkMsNERBQTREO1lBQzVELElBQUksQ0FBQyxLQUFLLENBQUMsQ0FDWCxDQUFBO1FBQ0YsQ0FBQzthQUFNLENBQUM7WUFDUCxJQUFJLEVBQUUsSUFBSSxFQUFFO2dCQUFFLE9BQU8sRUFBRSxDQUFBO1lBQ3ZCLDREQUE0RDtZQUM1RCxPQUFPLFFBQVEsQ0FBQyxFQUFFLEVBQUUsSUFBSSxDQUFDLEVBQUUsQ0FBQyxDQUFDLENBQUE7UUFDOUIsQ0FBQztJQUNGLENBQUMsQ0FDRCxDQUFBO0FBQ0YsQ0FBQztBQUVEOztHQUVHO0FBQ0gsTUFBTSxVQUFVLFFBQVEsQ0FDdkIsRUFBaUMsRUFDakMsS0FBa0I7SUFFbEIsSUFBSSxFQUFFLElBQUksc0JBQXNCO1FBQy9CLEVBQUUsR0FBRyxzQkFBc0IsQ0FBQyxFQUF5QixDQUFDLENBQUE7SUFDdkQsT0FBTyxHQUFHLENBQUMsRUFBYSxFQUFFLEtBQUssQ0FBQyxDQUFBO0FBQ2pDLENBQUMifQ==